/**
 * Error returned when Numeric range is not well-formed
 */
export default class MalformedRangeError extends Error {
  public ERROR_CODE = 'MALFORMED_RANGE';
  constructor(message : string) {
    super(message);
    Object.setPrototypeOf(this, MalformedRangeError.prototype);
  }
}
